<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
      page: {
         title: "Marketing Staffs Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Marketing Staffs Report",
            items: [
               {
                  text: "Marketing Staffs Report",
                  active: true,
               },                   
            ],

            earnings: [],    
            marketing_staffs: [],      
            marketing_staff_reports: [],  
            
            pagination: {},
            
            from_date: current_date,
            to_date: current_date,
            keyword: "",
            listing_length: 10,
            status: '',
            marketing_staff_id: '',
            token: "",
            errors: {},          
            active_page_url: null,
            loading: false,
            refferal_codes_count: 0,
            total_commission: 0,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },
      created() {
         this.fetchMarketingStaffReports();
         this.fetchMarketingStaffs();

      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         fetchMarketingStaffs() {  
            let url = "api/admin/marketing_staffs";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.marketing_staffs = responseData;
               })
               .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },  
         clearForm() {
               this.errors = {};  
         },

         fetchMarketingStaffReports(page_url = null) {

            this.getToken();
            let url = "api/admin/marketing_report?&limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&marketing_staff_id=" + this.marketing_staff_id;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;

            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.marketing_staff_reports = responseData.marketing_staffs.data;
                  this.refferal_codes_count = responseData.refferal_codes_count;
                  this.total_commission = responseData.total_commission;
                  
                  this.pagination = responseData.marketing_staffs.links;
                  this.from = responseData.marketing_staffs.from;
                  this.to = responseData.marketing_staffs.to;
                  this.total = responseData.marketing_staffs.total;
                  this.clearForm();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           this.errors = error.response.data.message;
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         downloadMarketingStaffsPdf(){

         let url = "api/admin/marketing_staff_report_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&marketing_staff_id=" + this.marketing_staff_id;         
         this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "MarketingStaffs_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })

         },

         downloadMarketingStaffsExcel() {
            let url = "api/admin/marketing_staff_excel_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword + "&marketing_staff_id=" + this.marketing_staff_id;         
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" // Specify blob response type
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "Marketingstaffs_report.xlsx";
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                  console.error("Error downloading PDF file:", error);
                  const reader = new FileReader();
                  reader.onload = (event) => {
                     const text = event.target.result;
                     const errorData = JSON.parse(text);
                     const errorMessage = errorData.message;
                     if(errorMessage){
                        this.errors = errorMessage;
                     }else{
                     this.$swal("", "Failed to download PDF file", "error");
                     }
                  };
                  reader.readAsText(error.response.data);
               })
         },
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     <div class="form-group col-lg-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <b-form-input type="date" v-model="to_date" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     
                     <div class="form-group col-lg-4">
                        <label>Marketting staff</label>
                        <select class="form-control" v-model="marketing_staff_id" >
                           <option value="">All</option>
                           <option v-for="marketing_staff in marketing_staffs" :key="marketing_staff.id" :value="marketing_staff.id">{{marketing_staff.name}}</option>
                        </select>
                     </div>
                     
                  </div>
                  <!----- filters area ends---->

                  <div class="row align-items-center">
                     <div class="col-12 col-lg-7">
                        <button class="btn btn-primary me-2 mb-2 mb-lg-0" type="button" @click="fetchMarketingStaffReports()">View</button>
                        <button class="btn btn-primary me-2 mb-2 mb-lg-0" type="button" @click="downloadMarketingStaffsPdf()">Download PDF</button>
                        <button class="btn btn-primary me-2 mb-2 mb-lg-0" type="button" @click="downloadMarketingStaffsExcel()">Download Excel</button>
                     </div>
                     <div class="col-12 col-lg-5 mt-2 mt-lg-0 text-lg-end">
                        <div class="fw-semibold">Total Referrals: {{ refferal_codes_count }}</div>
                        <div class="fw-semibold">Total Commission: Rs.{{ total_commission }}</div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchMarketingStaffReports()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchMarketingStaffReports()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Patient Name</th>
                              <th>Contact</th>  
                              <th>Marketing Staff</th>
                              <th>Referral Code</th>
                              <th>Commision</th>
                              <th>Created at</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="marketing_staff_report in marketing_staff_reports" :key="marketing_staff_report.id">
                              <td>{{marketing_staff_report.patient_name}}</td>                       
                              <td>
                                 {{marketing_staff_report.patient_country_code}}  {{ marketing_staff_report.patient_mobile}}<br>
                                 {{marketing_staff_report.patient_email}}<br>
                              </td>
                              <td>
                                 {{marketing_staff_report.marketing_staff_name}}<br>
                                 +91 {{marketing_staff_report.marketing_staff_mobile}}<br>

                              </td>
                              <td>{{marketing_staff_report.marketing_staff_referral_code}}</td>
                              <td>Rs.{{marketing_staff_report.commission}}</td>
                              <td>{{marketing_staff_report.created_at|formatDateTime}}</td>
                              <td>
                                 <router-link :to="{ name: 'patients.details', params:{id:marketing_staff_report.patient_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Patient Profile</router-link>
                                 <router-link :to="{ name: 'marketingstaffs.details', params:{id:marketing_staff_report.marketing_staff_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Marketting Staff Profile</router-link>      


                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(marketing_staff_reports.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchMarketingStaffReports(page.url + '&limit='+ listing_length + '&from_date='+ from_date + '&to_date=' + to_date + '&keyword=' + keyword + '&marketing_staff_id=' + marketing_staff_id)">
                        <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                        <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                        <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
